/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WalletRouteImport } from './routes/wallet'
import { Route as SpawnRouteImport } from './routes/spawn'
import { Route as MarketplaceRouteImport } from './routes/marketplace'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LibraryRouteImport } from './routes/library'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as MarketplaceIndexRouteImport } from './routes/marketplace.index'
import { Route as LibraryIndexRouteImport } from './routes/library.index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as MarketplaceIdRouteImport } from './routes/marketplace.$id'
import { Route as LibraryIdRouteImport } from './routes/library.$id'
import { Route as DocsIntroRouteImport } from './routes/docs.intro'
import { Route as AuthOauthErrorRouteImport } from './routes/auth.oauth-error'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminPricingRouteImport } from './routes/admin/pricing'
import { Route as AdminFlagsRouteImport } from './routes/admin/flags'
import { Route as AAutomatonNameRouteImport } from './routes/a/$automatonName'
import { Route as MeMfaEnrollRouteImport } from './routes/me/mfa/enroll'

const WalletRoute = WalletRouteImport.update({
  id: '/wallet',
  path: '/wallet',
  getParentRoute: () => rootRouteImport,
} as any)
const SpawnRoute = SpawnRouteImport.update({
  id: '/spawn',
  path: '/spawn',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketplaceRoute = MarketplaceRouteImport.update({
  id: '/marketplace',
  path: '/marketplace',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryRoute = LibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const MarketplaceIndexRoute = MarketplaceIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MarketplaceRoute,
} as any)
const LibraryIndexRoute = LibraryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LibraryRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const MarketplaceIdRoute = MarketplaceIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => MarketplaceRoute,
} as any)
const LibraryIdRoute = LibraryIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => LibraryRoute,
} as any)
const DocsIntroRoute = DocsIntroRouteImport.update({
  id: '/docs/intro',
  path: '/docs/intro',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthOauthErrorRoute = AuthOauthErrorRouteImport.update({
  id: '/auth/oauth-error',
  path: '/auth/oauth-error',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminPricingRoute = AdminPricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminFlagsRoute = AdminFlagsRouteImport.update({
  id: '/flags',
  path: '/flags',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AAutomatonNameRoute = AAutomatonNameRouteImport.update({
  id: '/a/$automatonName',
  path: '/a/$automatonName',
  getParentRoute: () => rootRouteImport,
} as any)
const MeMfaEnrollRoute = MeMfaEnrollRouteImport.update({
  id: '/me/mfa/enroll',
  path: '/me/mfa/enroll',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/library': typeof LibraryRouteWithChildren
  '/login': typeof LoginRoute
  '/marketplace': typeof MarketplaceRouteWithChildren
  '/spawn': typeof SpawnRoute
  '/wallet': typeof WalletRoute
  '/a/$automatonName': typeof AAutomatonNameRoute
  '/admin/flags': typeof AdminFlagsRoute
  '/admin/pricing': typeof AdminPricingRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/oauth-error': typeof AuthOauthErrorRoute
  '/docs/intro': typeof DocsIntroRoute
  '/library/$id': typeof LibraryIdRoute
  '/marketplace/$id': typeof MarketplaceIdRoute
  '/admin/': typeof AdminIndexRoute
  '/library/': typeof LibraryIndexRoute
  '/marketplace/': typeof MarketplaceIndexRoute
  '/me/mfa/enroll': typeof MeMfaEnrollRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/spawn': typeof SpawnRoute
  '/wallet': typeof WalletRoute
  '/a/$automatonName': typeof AAutomatonNameRoute
  '/admin/flags': typeof AdminFlagsRoute
  '/admin/pricing': typeof AdminPricingRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/oauth-error': typeof AuthOauthErrorRoute
  '/docs/intro': typeof DocsIntroRoute
  '/library/$id': typeof LibraryIdRoute
  '/marketplace/$id': typeof MarketplaceIdRoute
  '/admin': typeof AdminIndexRoute
  '/library': typeof LibraryIndexRoute
  '/marketplace': typeof MarketplaceIndexRoute
  '/me/mfa/enroll': typeof MeMfaEnrollRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/library': typeof LibraryRouteWithChildren
  '/login': typeof LoginRoute
  '/marketplace': typeof MarketplaceRouteWithChildren
  '/spawn': typeof SpawnRoute
  '/wallet': typeof WalletRoute
  '/a/$automatonName': typeof AAutomatonNameRoute
  '/admin/flags': typeof AdminFlagsRoute
  '/admin/pricing': typeof AdminPricingRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/oauth-error': typeof AuthOauthErrorRoute
  '/docs/intro': typeof DocsIntroRoute
  '/library/$id': typeof LibraryIdRoute
  '/marketplace/$id': typeof MarketplaceIdRoute
  '/admin/': typeof AdminIndexRoute
  '/library/': typeof LibraryIndexRoute
  '/marketplace/': typeof MarketplaceIndexRoute
  '/me/mfa/enroll': typeof MeMfaEnrollRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/library'
    | '/login'
    | '/marketplace'
    | '/spawn'
    | '/wallet'
    | '/a/$automatonName'
    | '/admin/flags'
    | '/admin/pricing'
    | '/admin/users'
    | '/auth/oauth-error'
    | '/docs/intro'
    | '/library/$id'
    | '/marketplace/$id'
    | '/admin/'
    | '/library/'
    | '/marketplace/'
    | '/me/mfa/enroll'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/spawn'
    | '/wallet'
    | '/a/$automatonName'
    | '/admin/flags'
    | '/admin/pricing'
    | '/admin/users'
    | '/auth/oauth-error'
    | '/docs/intro'
    | '/library/$id'
    | '/marketplace/$id'
    | '/admin'
    | '/library'
    | '/marketplace'
    | '/me/mfa/enroll'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/library'
    | '/login'
    | '/marketplace'
    | '/spawn'
    | '/wallet'
    | '/a/$automatonName'
    | '/admin/flags'
    | '/admin/pricing'
    | '/admin/users'
    | '/auth/oauth-error'
    | '/docs/intro'
    | '/library/$id'
    | '/marketplace/$id'
    | '/admin/'
    | '/library/'
    | '/marketplace/'
    | '/me/mfa/enroll'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  LibraryRoute: typeof LibraryRouteWithChildren
  LoginRoute: typeof LoginRoute
  MarketplaceRoute: typeof MarketplaceRouteWithChildren
  SpawnRoute: typeof SpawnRoute
  WalletRoute: typeof WalletRoute
  AAutomatonNameRoute: typeof AAutomatonNameRoute
  AuthOauthErrorRoute: typeof AuthOauthErrorRoute
  DocsIntroRoute: typeof DocsIntroRoute
  MeMfaEnrollRoute: typeof MeMfaEnrollRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/wallet': {
      id: '/wallet'
      path: '/wallet'
      fullPath: '/wallet'
      preLoaderRoute: typeof WalletRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/spawn': {
      id: '/spawn'
      path: '/spawn'
      fullPath: '/spawn'
      preLoaderRoute: typeof SpawnRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketplace': {
      id: '/marketplace'
      path: '/marketplace'
      fullPath: '/marketplace'
      preLoaderRoute: typeof MarketplaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library': {
      id: '/library'
      path: '/library'
      fullPath: '/library'
      preLoaderRoute: typeof LibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketplace/': {
      id: '/marketplace/'
      path: '/'
      fullPath: '/marketplace/'
      preLoaderRoute: typeof MarketplaceIndexRouteImport
      parentRoute: typeof MarketplaceRoute
    }
    '/library/': {
      id: '/library/'
      path: '/'
      fullPath: '/library/'
      preLoaderRoute: typeof LibraryIndexRouteImport
      parentRoute: typeof LibraryRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/marketplace/$id': {
      id: '/marketplace/$id'
      path: '/$id'
      fullPath: '/marketplace/$id'
      preLoaderRoute: typeof MarketplaceIdRouteImport
      parentRoute: typeof MarketplaceRoute
    }
    '/library/$id': {
      id: '/library/$id'
      path: '/$id'
      fullPath: '/library/$id'
      preLoaderRoute: typeof LibraryIdRouteImport
      parentRoute: typeof LibraryRoute
    }
    '/docs/intro': {
      id: '/docs/intro'
      path: '/docs/intro'
      fullPath: '/docs/intro'
      preLoaderRoute: typeof DocsIntroRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/oauth-error': {
      id: '/auth/oauth-error'
      path: '/auth/oauth-error'
      fullPath: '/auth/oauth-error'
      preLoaderRoute: typeof AuthOauthErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/pricing': {
      id: '/admin/pricing'
      path: '/pricing'
      fullPath: '/admin/pricing'
      preLoaderRoute: typeof AdminPricingRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/flags': {
      id: '/admin/flags'
      path: '/flags'
      fullPath: '/admin/flags'
      preLoaderRoute: typeof AdminFlagsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/a/$automatonName': {
      id: '/a/$automatonName'
      path: '/a/$automatonName'
      fullPath: '/a/$automatonName'
      preLoaderRoute: typeof AAutomatonNameRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/me/mfa/enroll': {
      id: '/me/mfa/enroll'
      path: '/me/mfa/enroll'
      fullPath: '/me/mfa/enroll'
      preLoaderRoute: typeof MeMfaEnrollRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AdminRouteRouteChildren {
  AdminFlagsRoute: typeof AdminFlagsRoute
  AdminPricingRoute: typeof AdminPricingRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminFlagsRoute: AdminFlagsRoute,
  AdminPricingRoute: AdminPricingRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface LibraryRouteChildren {
  LibraryIdRoute: typeof LibraryIdRoute
  LibraryIndexRoute: typeof LibraryIndexRoute
}

const LibraryRouteChildren: LibraryRouteChildren = {
  LibraryIdRoute: LibraryIdRoute,
  LibraryIndexRoute: LibraryIndexRoute,
}

const LibraryRouteWithChildren =
  LibraryRoute._addFileChildren(LibraryRouteChildren)

interface MarketplaceRouteChildren {
  MarketplaceIdRoute: typeof MarketplaceIdRoute
  MarketplaceIndexRoute: typeof MarketplaceIndexRoute
}

const MarketplaceRouteChildren: MarketplaceRouteChildren = {
  MarketplaceIdRoute: MarketplaceIdRoute,
  MarketplaceIndexRoute: MarketplaceIndexRoute,
}

const MarketplaceRouteWithChildren = MarketplaceRoute._addFileChildren(
  MarketplaceRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  LibraryRoute: LibraryRouteWithChildren,
  LoginRoute: LoginRoute,
  MarketplaceRoute: MarketplaceRouteWithChildren,
  SpawnRoute: SpawnRoute,
  WalletRoute: WalletRoute,
  AAutomatonNameRoute: AAutomatonNameRoute,
  AuthOauthErrorRoute: AuthOauthErrorRoute,
  DocsIntroRoute: DocsIntroRoute,
  MeMfaEnrollRoute: MeMfaEnrollRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
